import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import MaterialModal from "@/Modals/WebDataManagement/MasterData/Materials/Modal";
import React from "react";
import { columns } from "./Columns";
import { materialsMasterDataApi } from "@/apis/apis";

export default function ProductSizesPage() {
  return (
    <MasterDataBaseTable
      label="Material"
      apiURL={materialsMasterDataApi}
      columns={columns()}
      ModalComponent={MaterialModal}
      importData={BASE_IMPORT_DATA.MATERIALS}
      enableStatus={false}
    />
  );
}
